import React, { useEffect } from 'react';
import DaApp from '@wix/da-shared-react/pkg/DaApp';
import { RuntimeEnvironment } from '@wix/da-shared-react/pkg/types';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import SharedDeviationPage from '@wix/da-shared-react/pkg/DeviationPage';
import { useScrollRestore } from '@wix/da-shared-react/pkg/Duperbrowse/hooks/useScrollRestore';
import DrawerLoadable from '@wix/da-feedback-shared/pkg/Drawer/DrawerLoadable';
import FeedbackPageLoadable from '@wix/da-feedback-shared/pkg/FeedbackPage/FeedbackPageLoadable';
import { DuperbrowseViewContext } from '@wix/da-shared-react/pkg/Duperbrowse/DuperbrowseViewContext';
import { PapiDeviation } from '@wix/da-papi-types';
import { composeModalRenderers } from '@wix/da-shared-react/pkg/Modals/helpers';
import { adoptsModalRenderer } from '@wix/da-adopts-shared/pkg/project-tools';
import { submitModalRenderer } from '@wix/da-submit-shared/pkg/project-tools';
import './App.scss';

export interface Props {
  language: string;
  deviation?: PapiDeviation;
  isFeedbackPageOpen?: boolean;
  environment?: RuntimeEnvironment;
  appLoaded: () => void;
}

const App: React.FC<Props> = ({
  language,
  deviation,
  isFeedbackPageOpen,
  environment,
  appLoaded,
}) => {
  useEffect(() => {
    appLoaded();
  }, [appLoaded]);

  useScrollRestore(!!isFeedbackPageOpen);
  return (
    <DaApp
      language={language}
      environment={environment}
      isDuperbrowseEnabled={false}
      disablePageWideNotifications
      ncContextProps={{
        PageComponent: FeedbackPageLoadable,
        DrawerComponent: DrawerLoadable,
      }}
      modalsRenderFunc={composeModalRenderers(
        adoptsModalRenderer,
        submitModalRenderer
      )}
    >
      <ErrorBoundary debugComponent="DeviationApp">
        {isFeedbackPageOpen ? (
          <FeedbackPageLoadable />
        ) : (
          <DuperbrowseViewContext.Provider value="fullscreen">
            <SharedDeviationPage deviation={deviation} />
          </DuperbrowseViewContext.Provider>
        )}
      </ErrorBoundary>
    </DaApp>
  );
};
App.displayName = 'App';

export default App;
